"use strict";

class OrganisationOverviewCtrl {

    constructor($http, $state, $mdDialog, $scope, $mdToast, $location) {

        this.$http = $http;
        this.$state = $state;
        this.$location = $location;

        this.data = {};
        this.card = {};
        this.subscriptions = [];
        this.subscriptions_discount = {amount: 0};
        this.coupon = '';
        this.invoices = {};
        this.customer = {};
        this.discount = 0;
        this.$mdDialog = $mdDialog;
        this.scope = $scope;
        this.scope.$http = $http;
        this.$mdToast = $mdToast;
        this.address_fields = [{}];
        this.removeCardDisabled = false;
        this.selectedTab = (this.$location.search()).tab || 0;
        this.stations = {};
        this.count = {
            user: 0,
            station: 0
        };
        this.maxReach = {
            user: false,
            station: false
        };

        //for user management
        this.selectedUser = null;
        this.searchText = '';

        this.fetch();
    }


    fetch() {
        this.$http.get("/organisation/get").then((response) => {
            angular.extend(this.data, response.data);

            //Dirty fix for the backend
            this.address_fields = [];
            for (let i = 0; i < 3; i++) {

                if (this.data['address_line' + (i + 1)]) {

                    this.address_fields.push({address: this.data['address_line' + (i + 1)]});
                }
            }

            if (this.address_fields.length === 0) {

                this.address_fields.push({});
            }
        });

        this.$http.get('/organisation/user-subscription').then((response) => {
            this.count.user = response.data.amount;
        });

        this.billing_data();

        this.station_overview();
    }


    save() {
        this.buttonDisabled = true;
        if (this.subscriptions.length) {
            this.update_quantity();
            this.updateCardAddress();
            this.$http.post('/billing/customer/update', {email: this.customer.email}).then((data) => {
                //get new stations data
            });
        }


        //Dirty fix for the backend
        for (let i = 0; i < 3; i++) {
            this.data['address_line' + (i + 1)] = this.address_fields[i] ? this.address_fields[i].address : null;
        }

        this.$http.put("/organisation/put", this.data).then((response) => {
            angular.extend(this.data, response.data);
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.object_saved?object=settings', //@trans('labels.settings')
                hideDelay: 6000,
                position: ('top right')
            });
            this.station_overview();
            this.buttonDisabled = false;
        });
    }


    manageAddressFields(type, $event, $index) {

        $event.preventDefault();

        if (type == 'add') {

            this.address_fields.push({});
        } else {

            this.address_fields.splice($index, 1);
        }
    }


    billing_data() {

        this.$http.get("/billing/overview").then((response) => {
            if (response.data.status == 'not found') {
                return;
            }
            let customer = response.data.customer;
            let card = response.data.customer.sources.data[0];
            let subscriptions = response.data.customer.subscriptions.data;
            let invoices = response.data.invoices.data.map(function (invoice) {
                let period_start = new Date(invoice.period_start * 1000);
                let period_end = new Date(invoice.period_end * 1000);

                invoice.period_start = period_start;
                invoice.period_end = period_end;
                invoice.lines.data = invoice.lines.data.map(function (line) {
                    line.period.start = new Date(line.period.start * 1000);
                    line.period.end = new Date(line.period.end * 1000);
                    return line;
                });

                return invoice;
            });
            if (customer.discount) {
                this.coupon = customer.discount.coupon.id;
                this.checkCoupon(this.coupon);
            }

            this.customer = customer;
            this.card = card;
            this.subscriptions = subscriptions;
            this.invoices = invoices;
        });
    }


    update_quantity() {
        //check if subscriptions are not to low
        let error;
        this.subscriptions.forEach((subscription) => {
            if (subscription.quantity === undefined) {
                this.$mdToast.show(
                    this.$mdToast.simple()
                        .content('There is a problem with your subscription data')
                        .position('top right')
                        .hideDelay(3000)
                );
                error = true;
            }
        });
        if (error) {
            return;
        }
        this.$http.post("/billing/subscription/update", {'subscriptions': this.subscriptions});
    }


    createCard(customerCreate, $event) {
        if (customerCreate) {
            this.scope.createCustomer = true;
        } else {
            this.scope.createCustomer = false;
        }
        this.$mdDialog.show({
            controller: 'createCardInfoDialogCtrl',
            templateUrl: "createCardInfo.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: $event,
            escapeToClose: false,
            scope: this.scope,
            preserveScope: true
        }).then(() => {
            this.billing_data();
            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.create?object=Card&title=', //@trans('labels.Card')
                hideDelay: 3000,
                position: ('top right')
            }).then(() => {
                this.updateCardAddress();
            });
            if (customerCreate) {
                this.fetch();
            }
        })
    }


    updateCard($event) {
        this.$mdDialog.show({

            controller: 'changeCardInfoDialogCtrl',
            templateUrl: "changeCardInfo.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: $event,
            clickOutsideToClose: true,
            scope: this.scope,
            preserveScope: true
        }).then(() => {
            this.billing_data();
        })
    }


    removeCard(id, $event) {
        this.removeCardDisabled = true;

        this.$mdDialog.show({
            controller: 'ConfirmDialogCtrl',
            templateUrl: "confirmDialog.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: $event,
            clickOutsideToClose: true,
            preserveScope: true
        }).then(() => {
                this.$http.post("/billing/card/delete", {'id': id}).then(() => {
                    this.$mdToast.show({
                        templateUrl: '/partial/app.partials.toasts.delete?object=Card&title=' + id, //@trans('labels.Card')
                        hideDelay: 3000,
                        position: ('top right')
                    });
                    this.billing_data();
                    this.removeCardDisabled = false;
                });
            },
            (response) => {
                this.removeCardDisabled = false;
            });
    }


    createCustomer(email, $event) {
        this.scope.user_email = email;
        this.createCard(true, $event);
    }


    updateCardAddress() {
        let line = this.address_fields[0].address;
        if (line === undefined) {
            line = 'NULL';
        }
        this.$http.post("/billing/card/address/update", {
            id: this.card.id,
            city: this.data.city,
            country: this.data.country,
            zip: this.data.zipcode,
            line: line
        });
    }


    checkCoupon(coupon) {
        this.$http.get('/billing/coupon/check/' + coupon).then((data) => {
            let couponObj = data.data.coupon;
            this.subscriptions_discount = {amount: couponObj.amount_off};
            this.addCoupon();
        }, (data) => {
            this.subscriptions_discount = {amount: 0};
        });
    }


    addCoupon() {
        if (this.coupon) {
            this.$http.post('/billing/coupon/attach', {token: this.coupon}).then((data) => {
            });
        }
    }


    station_overview() {
        this.$http.get('/organisation/stations').then((response) => {
            this.stations = response.data;
        });
        this.$http.get('/organisation/station-subscription').then((response) => {
            this.count.station = response.data.amount;
            this.maxReach.station = response.data.maxReached;
        });
    }


    stationRemove(stationData, $event) {

        this.$mdDialog.show({
            controller: 'stationRemoveDialogCtrl',
            templateUrl: "stationRemove.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: $event,
            escapeToClose: false,
            locals: {
                station: stationData
            }
        }).then(() => {
            this.$http.delete('/station/destroy/' + stationData.id).then((response) => {
                console.log(response);
                if(response.data === "removed"){
                    this.$mdToast.show({
                        templateUrl: '/partial/app.partials.toasts.delete?object=Station&title=' + stationData.name, //@trans('labels.Station')
                        hideDelay: 3000,
                        position: ('top right')
                    });
                } else {
                    this.$mdToast.show({
                        templateUrl: '/partial/app.partials.toasts.error_message?plain_error=Failed%20to%20remove:%20' + stationData.name,
                        hideDelay: 3000,
                        position: ('top right')
                    });
                }

                this.station_overview();
            });
        });
    }


    stationAdd(organisationData, $event) {
        if (this.maxReach.station) {
            return;
        }
        this.$mdDialog.show({
            controller: 'stationAddDialogCtrl',
            templateUrl: "stationAdd.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: $event,
            escapeToClose: false,
            locals: {
                organisation: organisationData
            }
        })
            .then((name) => {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.create?object=Station&title=' + name, //@trans('labels.Station')
                    hideDelay: 3000,
                    position: ('top right')
                });
                this.station_overview();
            });
    }


    onTabSelect(tab) {

        //Ugly Hack   double firing
        if (typeof (this.selectedTab) == 'string') {

            return;
        }

        this.$location.search('tab', tab);
    }


    organisationUserSearch(query) {
        //dont send empty queries to the backend
        if (!query) {
            return [];
        }

        return this.$http.get('/organisation/users/search/' + encodeURIComponent(query)).then(response => {

            return response.data;
        });
    }


    organisationUserAdd(user) {
        return this.$http.post('/organisation/users/' + user.id).then(response => {

            this.$mdToast.show({
                templateUrl: '/partial/app.partials.toasts.saved?object=Administrative_user&title=' + user.firstname + '%20' + user.lastname, //@trans('labels.Administrative_user')
                hideDelay: 3000,
                position: ('top right')
            });

            this.data.users.push(user);

            this.selectedUser = null;
            this.searchText = '';
        });
    }


    organisationUserRemove(user, index, ev) {
        this.$mdDialog.show({

            controller: 'ConfirmDialogCtrl',
            templateUrl: "confirmDialog.ngTemplate",
            parent: angular.element(document.querySelector('#popupContainer')),
            targetEvent: ev,
            clickOutsideToClose: true
        }).then(() => {

            this.$http.delete('/organisation/users/' + user.id).then(response => {
                this.$mdToast.show({
                    templateUrl: '/partial/app.partials.toasts.delete?object=Administrative_user&title=' + user.firstname + '%20' + user.lastname, //@trans('labels.Administrative_user')
                    hideDelay: 3000,
                    position: ('top right')
                });

                this.data.users.splice(index, 1);
            });
        });

    }
}

OrganisationOverviewCtrl.$inject = ['$http', '$state', '$mdDialog', '$scope', '$mdToast', '$location'];

module.exports = OrganisationOverviewCtrl;
